import { render } from "./ItemType.vue?vue&type=template&id=0618dbe8"
import script from "./ItemType.vue?vue&type=script&lang=js"
export * from "./ItemType.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__